import { styled } from '@clickcease/cc-client-components-lib'

export const MainWrapper = styled('div', {
  background: '$offWhite',
  display: 'flex',
  width: '100%',
  height: '100%',
  padding: '$10',
  gap: '$10',
  boxSizing: 'border-box',
  overflow: 'auto',

  '.container': {
    display: 'flex',
    flexDirection: 'column',
    gap: '$10',
    flexGrow: 1,
  },

  variants: {
    bannerShown: {
      true: {
        height: 'calc(100% - 46px)',
      },
    },
  },
})
